import React, { useState, Fragment, useEffect } from 'react';
import { GlobalStyles, Box, Typography } from '@mui/material';

import { Calendar, dateFnsLocalizer, View } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './styles/index.css';

import useUserProfile from '../../../../hooks/useUserProfile';
import { getFormattedTimezone } from '../../../../utils/helpers';
import { COLORS } from '../../../../utils/colors';

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales: { 'en-US': enUS },
});

const AvailabilityCalendar = ({
  showSave,
  currentView,
  setCurrentView,
  currentDate,
  setCurrentDate,
}: {
  showSave: boolean;
  currentView: View;
  setCurrentView: (view: View) => void;
  currentDate: Date;
  setCurrentDate: (date: Date) => void;
}) => {
  const { getAvailability } = useUserProfile();
  const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    getAvailability().then((response) => {
      if (
        !response?.success ||
        !response?.data?.availability ||
        !response?.data?.timezone
      )
        return;

      console.log('::::::response:', response);

      setEvents(
        response.data.availability.map((entry: any) => {
          const start = new Date(entry.from);
          const end = new Date(entry.to);
          return {
            title: 'Available',
            start,
            end,
          };
        }),
      );
    });
  }, [showSave]);

  console.log('::::::events:', events);

  return (
    <Box sx={{ marginBottom: '2rem', mt: '1rem' }}>
      {showSave && (
        <Typography
          variant="h4"
          sx={{ mb: '2rem', textAlign: 'center', color: COLORS.PRIMARY }}>
          Save changes to see updated availability calendar
        </Typography>
      )}
      <Typography variant="h6" sx={{ mb: '2rem' }}>
        Timezone: {getFormattedTimezone()}
      </Typography>

      <Fragment>
        <GlobalStyles
          styles={{
            '.rbc-month-row': {
              minHeight: '7.5rem',
            },
          }}
        />
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{
            height: currentView === 'month' ? '' : 'calc(100vh - 20rem)',
          }}
          views={['month', 'week', 'day']}
          view={currentView}
          onView={(view) => setCurrentView(view)}
          date={currentDate}
          onNavigate={(date) => setCurrentDate(date)}
          defaultView="month"
          dayPropGetter={() => ({ style: {} })}
          eventPropGetter={() => ({ style: {} })}
        />
      </Fragment>
    </Box>
  );
};

export default AvailabilityCalendar;
